'use strict';

namespace Core {

    class ScrollerCtrl {

        private target: string;
        private offset: string;

        constructor(
            private $scope: ng.IScope,
            private scrollService: any,
        ) {
        }

        scroll(): void {
            const options: {animate: boolean, offset: string, container?: string} = {
                animate: true,
                offset: this.offset
            };

            if (angular.element('.scroller-relative-container').length !== 0) {
                options.container = '.scroller-relative-container';
            }

            this.scrollService.scrollTo(this.target, options);
        }
    }

    angular
        .module('core')
        .directive('scroller', (): ng.IDirective => {

        return {
            bindToController: {
                target: '@',
                offset: '@',
                linkClass: '@'
            },
            controller: ScrollerCtrl,
            controllerAs: 'scr',
            replace: false,
            restrict: 'E',
            scope: {},
            template: '<a href="" ng-click="scr.scroll()" ng-class="scr.linkClass" ng-transclude></a>',
            transclude: true
        };
    });
}
